import * as THREE from 'three/webgpu';
import type { SketchGroup } from '../../../../mesh/sketch/SketchGroup';
import { SketchCircleObject } from '../../../../mesh/sketch/SketchCircleObject';
import type { ProjectionResult } from '../../model/ProjectionResult';
import type {
	CircleReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/CircleReferenceBuilder';

export type {
	CircleReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/CircleReferenceBuilder';

/**
 * 圆引用构建器。
 * 说明：
 * 1. 只负责把圆投影结果转成正式草图圆对象；
 * 2. 构造后立即刷新几何，避免首次挂载时缺少 position attribute。
 */
export class CircleReferenceBuilder {
	/**
	 * 构建草图圆对象。
	 *
	 * @param input 构建输入。
	 * @returns 已完成几何初始化的圆对象。
	 */
	public build(input: CircleReferenceBuilderInput): SketchCircleObject {
		const circle = new SketchCircleObject({
			center: new THREE.Vector3(...input.geometryPayload.centerWorld),
			radius: input.geometryPayload.radius,
			referencePlane: input.targetSketch.referencePlane,
		});

		circle.updateGeometry();
		return circle;
	}
}
